import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { constants } from 'utils/Constant';
import routes from 'routes.js';
import DashboardNavbar from 'components/navbars/DashboardNavbar';

const T = {
  bg:   '#F6F5F0',
  soft: '#F0EEE6',
  ink:  '#232821',
  bg_c: '#FFFFFF',
};

const DashboardLayout = () => {

  /* ── Google Fonts + body reset ── */
  React.useEffect(() => {
    const id = 'finalyze-gfonts';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id   = id;
      link.rel  = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@400;700;800&family=Instrument+Sans:wght@400;500;600;700&display=swap';
      document.head.appendChild(link);
    }
    const prev = {
      bg: document.body.style.background,
      m:  document.body.style.margin,
      p:  document.body.style.padding,
      ov: document.body.style.overflow,
    };
    document.body.style.background = T.bg;
    document.body.style.margin     = '0';
    document.body.style.padding    = '0';
    document.body.style.overflow   = 'hidden';
    return () => {
      document.body.style.background = prev.bg;
      document.body.style.margin     = prev.m;
      document.body.style.padding    = prev.p;
      document.body.style.overflow   = prev.ov;
    };
  }, []);

  /* ── route builder ── */
  const getRoutes = (list) =>
    list.map((prop, key) => {
      if (prop.collapse) return getRoutes(prop.views);
      if (prop.layout === constants.finalyze) {
        return (
          <Route
            key={key}
            path={prop.layout + prop.path}
            component={prop.component}
          />
        );
      }
      return null;
    });

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      background: T.bg,
      fontFamily: "'Instrument Sans', system-ui, sans-serif",
    }}>

      {/* Scoped utility styles */}
      <style>{`
        .dml-tab   { transition: background 0.15s, color 0.15s, border-color 0.15s; }
        .dml-tab:hover { background: ${T.ink} !important; color: ${T.bg} !important; border-color: ${T.ink} !important; }
        .dml-logo:hover { opacity: 0.75; }
        .dml-theme:hover { background: ${T.soft} !important; }
        .dml-scroll::-webkit-scrollbar { display: none; }
        .dml-content::-webkit-scrollbar { width: 6px; }
        .dml-content::-webkit-scrollbar-thumb { background: rgba(128,128,128,.25); border-radius: 3px; }
        .dml-content::-webkit-scrollbar-track  { background: transparent; }
      `}</style>

      {/* Top bar + Tab nav */}
      <DashboardNavbar />

      {/* Scrollable content */}
      <div
        id="dml-content-scroll"
        className="dml-content"
        style={{
          flex: 1,
          overflowY: 'auto',
          background: T.bg,
          padding: '16px 0 60px',
        }}
      >
        <Switch>{getRoutes(routes)}</Switch>
      </div>
    </div>
  );
};

export default DashboardLayout;
